import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import { MatIconModule } from '@angular/material/icon';
import { AccountRegisterSelectorComponent } from './account-register-selector.component';
import { LFDropdownModule } from '../../../../shared/dropdown/dropdown.module';
import { ReportsService } from '../../../../../services/reports/reports.service';

@NgModule({
    imports: [
        SharedModule,
        MatIconModule,
        LFDropdownModule,
    ],
    declarations: [AccountRegisterSelectorComponent],
    exports: [AccountRegisterSelectorComponent],
    providers: [
        ReportsService,
    ],
})
export class AccountRegisterSelectorModule
{
}
